import React from "react";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

interface PrimaryConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isSaving: boolean;
  existingPrimaryContactName?: string;
  newContactName: string;
}

const PrimaryConfirmDialog: React.FC<PrimaryConfirmDialogProps> = ({
  open,
  onCancel,
  onConfirm,
  isSaving,
  existingPrimaryContactName,
  newContactName,
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    maxWidth="xs"
    fullWidth
    PaperProps={{ sx: { borderRadius: "12px" } }}
  >
    <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pb: 1 }}>
      Change Primary Contact?
    </DialogTitle>
    <DialogContent>
      <Box>
        <Typography variant="body2" color="text.primary">
          The current primary contact for this client is{" "}
          <strong>"{existingPrimaryContactName}"</strong>. Would you like
          to change <strong>"{newContactName}"</strong> as the new Primary
          contact?
        </Typography>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1.5 }}>
        The existing primary contact will be unset automatically.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ p: 2.5, pt: 1 }}>
      <Button onClick={onCancel} color="inherit">
        Cancel
      </Button>
      <Button onClick={onConfirm} variant="contained" disabled={isSaving}>
        {isSaving ? <CircularProgress size={20} /> : "Confirm Change"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default PrimaryConfirmDialog;
